import {
  ApplicationConfig,
  LOCALE_ID,
  provideZoneChangeDetection
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { environment } from './../environments/environment.qa';

import { HTTP_INTERCEPTORS, provideHttpClient } from '@angular/common/http';
import { CsIconModule, CsIconRegistryService } from '@cbuild/controls';
import {
  AuthenticationService,
  FIREBASE_CONFIG,
  LoginGuard,
  TokenInterceptorService
} from '@cbuild/core';
import {
  CsHttpClientService,
  JwtService,
  LOGIN_ROUTE,
  NO_ACCESS,
  StorageService
} from '@cbuild/cs-common-data-services';
import { initializeApp } from 'firebase/app';
import { routes } from './app.routes';
import { NavMenuService } from './core/nav-menu/nav-menu.service';
import { CsCommonDataModule } from '@cbuild/cs-common-data-services';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CsDialogModule } from '@cbuild/dialog';
import { NGX_ECHARTS_CONFIG } from 'ngx-echarts';
import * as echarts from 'echarts/core';
import { PieChart, BarChart } from 'echarts/charts';
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent
} from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';

// Register required ECharts components
echarts.use([
  PieChart,
  BarChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  CanvasRenderer
]);

initializeApp(environment.firebaseConfig);
const csCommonDataProviders =
  CsCommonDataModule.forRoot({
    loginRoute: '/accounts/login',
    noAccess: '/accounts/no-access'
  }).providers ?? [];
export const appConfig: ApplicationConfig = {
  providers: [
    ...csCommonDataProviders,
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(),
    {
      provide: NGX_ECHARTS_CONFIG,
      useFactory: () => ({ echarts })
    },
    StorageService,
    AuthenticationService,
    JwtService,
    CsHttpClientService,
    NavMenuService,
    CsIconRegistryService,
    LoginGuard,
    BrowserModule,
    BrowserAnimationsModule,
    CsIconModule,
    CsDialogModule,
    { provide: LOGIN_ROUTE, useValue: 'accounts/login' },
    { provide: NO_ACCESS, useValue: '/no-access' },
    { provide: FIREBASE_CONFIG, useValue: environment.firebaseConfig },

    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptorService,
      multi: true
    },
    {
      provide: LOCALE_ID,
      useValue: 'en-IN'
    }
  ]
};
